import PropTypes from 'prop-types';
import React from 'react';
import CompleteTaskModal from 'CompleteTaskModal';
import ReactSelect from 'components/StyledSelect/react_select';
import PhaseType from 'types/phase';
import TaskType from 'types/task';
import { error } from '../../../../../../../../../utils';
import modalStyles from 'modal.scss';

const ALLOWED_STATUSES = ['scheduling', 'hold', 'waiting_for_product'];

class VerifyContractModal extends CompleteTaskModal {
  static VALIDATIONS = { note: 'This field is required.', phaseStatus: 'Please select a status.' }
  static DEFAULT_STATE = {
    phaseStatus: 'scheduling',
    note: '',
    errors: {},
    sendError: false,
  }

  data() {
    return {
      ...super.data(),
      phase: { status: 'waiting_for_product' },
    };
  }

  handleSelectChange = (option) => {
    this.setState({ phaseStatus: option.value });
  }

  render() {
    const { errors, phaseStatus } = this.state;
    const { phase } = this.props;
    const availableStatuses = phase.available_statuses || [];
    let statuses = availableStatuses.filter(s => ALLOWED_STATUSES.includes(s.value));
    // Remove 'waiting_for_product' from statuses if the store doesn't deliver
    if (phase.store.delivery_method === 'None') {
      statuses = statuses.filter(s => s.value !== 'waiting_for_product');
    }

    return super.render(
      <ReactSelect
        className={[modalStyles.select, modalStyles.largerModal].join(' ')}
        label="Select Status"
        required
        onChange={this.handleSelectChange}
        options={statuses}
        resetValue={[]}
        value={phaseStatus}
        error={error('phaseStatus', errors)}
      />,
      error('status', errors),
    );
  }
}

VerifyContractModal.propTypes = {
  active: PropTypes.bool.isRequired,
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  onClose: PropTypes.func.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
};

VerifyContractModal.defaultProps = {
  active: false,
};

export default VerifyContractModal;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/verify_contract/components/VerifyContractModal.jsx